<div class="col-12" style=" margin-top: 15px;">
  <h4> {{"shoppingbybrand"| transloco }}</h4>
</div>
<div class="scroll-menu tags">
  <div class="scroll-item" (click)="getAllbrands(0)">
    <img src="/assets/e-commerce/icons/76.webp">
    <p>{{"globrands"| transloco }}</p>
  </div>

  <div class="scroll-item" (click)="getAllbrands(1)">
    <img src="/assets/e-commerce/icons/75.webp">
    <p>{{"egybrands"| transloco }}</p>
  </div>
</div>
<div class="scroll-menu brands">
  <ng-container *ngFor="let el of allBrands; let i = index">
    <div class="scroll-item brands" (click)="bybrand(el)" id="0">

      <img [src]="fixImage(el.brand_logo)">

      <p> @if(isAr){
        {{el.brandname_ar}}
        }
        @else{
        {{el.brandname_en}}
        }</p>
    </div>
  </ng-container>

</div>